import { render } from "./EndpointConfig.vue?vue&type=template&id=87ea1b16&scoped=true&lang=pug"
import script from "./EndpointConfig.vue?vue&type=script&lang=js"
export * from "./EndpointConfig.vue?vue&type=script&lang=js"

import "./EndpointConfig.vue?vue&type=style&index=0&id=87ea1b16&lang=scss"
import "./EndpointConfig.vue?vue&type=style&index=1&id=87ea1b16&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87ea1b16"]])

export default __exports__